<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<div (click)="toggleParent()"
  [style.padding-left.px]="indentMargin"
  class="option"
  data-cy="chip-selector-zone-dropdown-option">
  <div class="arrow {{arrowVisibilityCssClass}}">
    <span class="{{arrowToggleCssClass}}"></span>
  </div>

  @if (hasChildren) {
    <div class="item">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </div>
  } @else {
    <div (click)="closeParent(undefined)"
      class="item"
      ngbDropdownItem>
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </div>
  }
</div>
@for (option of option.children; track option) {
  <div class="{{childrenContainerClass}}" data-cy="chip-selector-zone-dropdown-children-option">
    <app-chip-selector-zone-dropdown-option (close)="closeParent($event)"
      (selectedOption)="selectedOption.emit($event)"
      [indentLevel]="indentLevel + 1"
    [option]="option"></app-chip-selector-zone-dropdown-option>
  </div>
}

<!-- It's impossible to have a conditional directive (ngbDropdownItem), so this is the only way to avoid code duplication -->


<ng-template #itemWithChildren>
  <div class="item">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </div>
</ng-template>


<ng-template #itemWithoutChildren>
  <div (click)="closeParent(undefined)"
    class="item"
    ngbDropdownItem>
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </div>
</ng-template>


<ng-template #itemContent>
  <app-tooltip [dynamic]="isTooltipDynamic" [message]="itemTooltip">
    <span class="title">{{title}}</span>
  </app-tooltip>
  @if (hasDescription) {
    <div
    class="description">{{description}}</div>
  }
</ng-template>


<ng-template #tooltipTemplate>
  <ng-container *ngTemplateOutlet="option.tooltip; context: $safeNavigationMigration(option?.value)"></ng-container>
</ng-template>
